export { ValidarDocumento } from './ValidarDocumento'
